import type { Connection } from '../services/admin-api';
import { MYSQL_SSL_MODES } from './connection-labels';
import { normalizeSqlHost, type MysqlForm, type SqlServerForm } from './form-rules';

export const emptySqlServer = (editing?: Connection): SqlServerForm => ({
  host: editing?.host ?? '',
  port: String(editing?.port ?? 1433),
  database: editing?.database ?? '',
  schema: editing?.schema ?? '',
  authType: editing?.authType === 'entra-sp' ? 'entra-sp' : 'sql',
  user: editing?.user ?? '',
  tenantId: editing?.tenantId ?? '',
  clientId: editing?.clientId ?? '',
  encrypt: editing?.encrypt ?? true,
  trustServerCertificate: editing?.trustServerCertificate ?? false,
  secret: '',
});

export const emptyMysql = (editing?: Connection): MysqlForm => ({
  host: editing?.host ?? '',
  port: String(editing?.port ?? 3306),
  database: editing?.database ?? '',
  user: editing?.user ?? '',
  password: '',
  sslMode: MYSQL_SSL_MODES.find((mode) => mode.value === editing?.sslMode)?.value ?? 'verify-full',
});

/** Igual que el servidor: la credencial guardada solo sirve si no cambian servidor ni identidad. */
export function sqlServerSecretRequired(
  form: SqlServerForm,
  editing: Connection | undefined,
): boolean {
  if (editing?.connectorId !== 'sqlserver' || !editing.hasPassword) return true;
  const sp = form.authType === 'entra-sp';
  return (
    normalizeSqlHost(form.host) !== editing.host ||
    Number(form.port) !== editing.port ||
    form.authType !== editing.authType ||
    (sp ? '' : form.user.trim()) !== (editing.user ?? '') ||
    (sp ? form.tenantId.trim() : '') !== (editing.tenantId ?? '') ||
    (sp ? form.clientId.trim() : '') !== (editing.clientId ?? '')
  );
}

export function mysqlSecretRequired(form: MysqlForm, editing: Connection | undefined): boolean {
  if (editing?.connectorId !== 'mysql' || !editing.hasPassword) return true;
  return (
    normalizeSqlHost(form.host) !== editing.host ||
    Number(form.port) !== editing.port ||
    form.user.trim() !== editing.user
  );
}
